import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DevelopmentRouting } from './development.routings';
import { LanguageStringsComponent } from './language-strings/language-strings.component';
import { OrderByPipe } from 'angular-pipes/src/array/order-by.pipe';
import { DemoComponentComponent } from './demo-component/demo-component.component';
import { ViewTimeComponentModule } from '../view-time-component/view-time-component.module';

@NgModule({
  declarations: [
    LanguageStringsComponent,
    OrderByPipe,
    DemoComponentComponent
    
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    DevelopmentRouting,
    ViewTimeComponentModule
  ],
  exports: [LanguageStringsComponent],
})
export class DevelopmentModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/development/development.module.ts